/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PreviewBookingDto = {
    /**
     * Follow-up plan UUID. When set, expert and sub-service are derived from the plan and expert_id / sub_service_id are not required.
     */
    followup_plan_id?: string;
    /**
     * Expert UUID. Required unless followup_plan_id is set.
     */
    expert_id?: string;
    /**
     * Sub-service UUID. Required unless followup_plan_id is set.
     */
    sub_service_id?: string;
    /**
     * Package UUID (for package bookings)
     */
    package_id?: string;
    /**
     * Session type
     */
    session_type: PreviewBookingDto.session_type;
    /**
     * Mode (used for single-session pricing lookup)
     */
    mode: PreviewBookingDto.mode;
};
export namespace PreviewBookingDto {
    /**
     * Session type
     */
    export enum session_type {
        SINGLE = 'single',
        DUO = 'duo',
    }
    /**
     * Mode (used for single-session pricing lookup)
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
}

